<template>
  <v-container class="mt-10">
    <v-row class="fill-height" justify="center" align="center">
      <v-col cols="12" class="my-10">
        <h1 class="text-h2 mb-5">{{ $t('Global.App.welcome') }}</h1>
        <h4 class="text-h4">
          <span class="primary--text">{{ $t('Global.App.consult') }}.</span> <span class="secondary--text">{{ $t('Global.App.analyze') }}.</span> <span class="success--text">{{ $t('Global.App.share') }}.</span>
        </h4>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="8">
            <v-card shaped>
              <NewsSlider height="500px" isPublic/>
            </v-card>
          </v-col>
          <v-col cols="4">
            <DocumentsList isPublic/>
          </v-col>
        </v-row>
      </v-col>
      
    </v-row>
  </v-container>
</template>

<script>
import NewsSlider from '@/components/News/NewsSlider'
import DocumentsList from '@/components/Document/DocumentsList'

export default {
  components: { NewsSlider, DocumentsList }
}
</script>